import { createFileRoute } from "@tanstack/react-router";
import { SiteFooter, SiteHeader } from "@/components/tools/ToolShell";

export const Route = createFileRoute("/fr/disclaimer")({
  head: () => ({
    meta: [
      { title: "Mentions Légales — Picamini.online" },
      {
        name: "description",
        content: "Avis juridique et mentions légales du site Picamini.online.",
      },
    ],
    links: [
      { rel: "canonical", href: "https://picamini.online/fr/mentions-legales" },
      { rel: "alternate", hrefLang: "en", href: "https://picamini.online/disclaimer" },
      { rel: "alternate", hrefLang: "es", href: "https://picamini.online/es/aviso-legal" },
      { rel: "alternate", hrefLang: "de", href: "https://picamini.online/de/haftungsausschluss" },
      { rel: "alternate", hrefLang: "pt-BR", href: "https://picamini.online/pt-br/aviso-legal" },
      { rel: "alternate", hrefLang: "fr", href: "https://picamini.online/fr/mentions-legales" },
      { rel: "alternate", hrefLang: "x-default", href: "https://picamini.online/disclaimer" },
    ],
  }),
  component: FrDisclaimerPage,
});

function FrDisclaimerPage() {
  return (
    <div className="min-h-screen bg-background flex flex-col font-sans">
      <SiteHeader lang="fr" />

      <main className="flex-1 py-12 mx-auto max-w-4xl px-4 sm:px-6 lg:px-8 space-y-6">
        <h1 className="text-3xl sm:text-4xl font-extrabold text-foreground">Mentions Légales</h1>

        <p className="text-base text-muted-foreground leading-relaxed">
          Les informations et outils fournis sur <strong>Picamini.online</strong> sont mis à disposition à des fins pratiques, éducatives et de divertissement.
        </p>

        <h2 className="text-xl font-bold text-foreground pt-4">Caractère Aléatoire</h2>
        <p className="text-base text-muted-foreground leading-relaxed">
          Nos générateurs de nombres, roues et sélecteurs de prénoms s'appuient sur des algorithmes de tirage aléatoire pseudo-aléatoires standardisés pour assurer l'impartialité des tirages dans le cadre éducatif et ludique.
        </p>
      </main>

      <SiteFooter lang="fr" />
    </div>
  );
}
